import ColorScheme from './ColorScheme';
import GradientColorScheme from './GradientColorScheme';

class BlueColorScheme extends GradientColorScheme {
  static title = 'Blue';
  static value = 'blue';
  static description = 'Blue gradient scheme';
  static swatchColors = ['#0B2DA5', '#DE7F03', '#DE7F03'];

  static baseObjectColor = '#0B2DA5';
  static baseConnectorColor = '#DE7F03';
}

class ForestScheme extends ColorScheme {
  static title = 'Forest';
  static value = 'forest';
  static description = 'Forest color scheme with greens and browns';
  static swatchColors = ['#4FA55C', '#6E8928', '#B47C2A'];

  static objectColors = ['#4FA55C', '#6E8928', '#B47C2A', '#BF9C64'];
  static connectorColors = ['#B9DCC4', '#D1D5EA', '#E5D1AD'];
  static shapeColors = {
    roundRect: '#6E8928',
    rect: '#6E8928',
    circle: '#4FA55C',
    triangle: '#6E8928',
    diamond: '#B47C2A',
    parallelogram: '#6E8928',
    processEnd: '#4FA55C',
    cylinder: '#6E8928',
  };
}

class AmythestScheme extends ColorScheme {
  static title = 'Amythest';
  static value = 'amythest';
  static description = 'Amythest color scheme with purples and blues';
  static swatchColors = ['#471766', '#365FB1', '#CC5A6A'];

  static objectColors = ['#471766', '#365FB1', '#CC5A6A'];
  static connectorColors = ['#C7B9D0'];
  static shapeColors = {
    roundRect: '#471766',
    rect: '#471766',
    circle: '#CC5A6A',
    triangle: '#365FB1',
    diamond: '#365FB1',
    parallelogram: '#471766',
    processEnd: '#CC5A6A',
    cylinder: '#471766',
  };
}

const colorSchemes = [AmythestScheme, ForestScheme, BlueColorScheme];

export { colorSchemes };
export { BlueColorScheme, ForestScheme };
